import { Component, h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import Phrase from '../../libs/translationsUtils/phrase'
import Content from '../common/Content'
import Axios from 'axios'
import TopicMore from '../topic-list-view/TopicMore'
import TopicVote from '../topic-list-view/TopicVote'
import Editor from '../editor'
import Portal from 'preact-portal'
import {Person} from '../product-updates-destination/Types'
import TopicFavorite from '../topic-list-view/TopicFavorite'
import TopicPublicTags from '../topic-list-view/TopicPublicTags'
import PinnedReplyLabel from "../pinned-reply/PinnedReplyLabel";
import {PostType} from "../topic-list-view/Types";
import { LikedUserType } from '../topic-list-view/LikedUsers'
import VotedUsers from '../topic-list-view/VotedUsers'
import { common } from '../common'
import formatDateInLocalTimezone from '../utils/dateFormatDestination';
import Tooltip from '../ui-components/Tooltip';

interface IdeaType {
  'contentType': string,
  'id': string,
  'title': string,
  'content': string,
  'tags': Array<string>,
  'votedBy': Array<string>,
  'author': Person
}

interface Props {
  topic: IdeaType,
  currentUser: LikedUserType,
  pinnedReply: PostType | null,
  isSubscribed: boolean,
  currentPage: number
}

interface State {
  content: string | null,
  tags: Array<string>,
  isCurrentUserVoted: boolean,
  votedUsers: {
    [key: string]: LikedUserType
  },
  showEditor: boolean,
  isLoading: boolean,
  editorErrors: Array<{
    category: string,
    phrase: string
  }>,
  isSubscribed: boolean,
  hideFirstPost: boolean
}

class IdeationTopicView extends Component<Props, State> {
  private content: string | null = null
  private canUserEditPost: boolean = ['roles.administrator', 'roles.moderator', 'roles.super-admin'].includes(window.inSidedData.user.mainRole)
  private isProductAreasEnabled:boolean = common.isModuleActive('productAreas')

  constructor (props: Props) {
    super(props)
    this.state = {
      content: props.topic.content,
      isCurrentUserVoted: this.props.currentUser.id !== null && this.props.topic.votedBy.includes(this.props.currentUser.id.toString()),
      votedUsers: {},
      showEditor: false,
      isLoading: false,
      editorErrors: [],
      tags: props.topic.tags,
      isSubscribed: props.isSubscribed,
      hideFirstPost: props.currentPage > 1
    }
    this.toggleVoteStatus = this.toggleVoteStatus.bind(this)
    this.onChangeOpeningPost = this.onChangeOpeningPost.bind(this)
    this.toggleSubscription = this.toggleSubscription.bind(this)
    this.content = props.topic.content
  }

  async toggleSubscription () {
    const endpoint = `/ideas/${this.props.topic.id}/${this.state.isSubscribed ? 'unsubscribe' : 'subscribe'}` // this.state.isSubscribed ?
    await Axios.post(endpoint)

    this.setState({ isSubscribed: !this.state.isSubscribed })
  }

  async toggleVoteStatus () {
    if (this.props.currentUser.id === null) {
      const event = new CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    if (this.state.isCurrentUserVoted) {
      delete this.state.votedUsers[this.props.currentUser.id]
      this.setState({ votedUsers: this.state.votedUsers, isCurrentUserVoted: false })
      await Axios.post(`/community/api/ideas/${this.props.topic.id}/unvote`, {
        unvotedBy: this.props.currentUser.id
      })
    } else {
      this.setState({ votedUsers: { ...this.state.votedUsers, [this.props.currentUser.id]: this.props.currentUser }, isCurrentUserVoted: true })
      await Axios.post(`/community/api/ideas/${this.props.topic.id}/vote`, {
        votedBy: this.props.currentUser.id
      })
    }
  }

  async onChangeOpeningPost () {
    this.setState({ isLoading: true })
    try {
      await Axios.post(`/community/api/ideas/${this.props.topic.id}/editContent`, {
        content: this.content
      })
      this.setState({ showEditor: false, content: this.content, isLoading: false })
    } catch (e) {
      this.setState({ isLoading: false })
      if (e.response?.data?.errors?.content) {
        this.setState({ editorErrors: [{ category: 'Forum', phrase: 'validation.text.required' }] })
      } else {
        this.setState({ editorErrors: [{ category: 'Forum', phrase: `Something's gone wrong` }] })
      }
    }
  }

  async componentDidMount () {
    if (this.props.topic.votedBy.length) {
      const res = await Axios.post('/member/getUsersById', {
        ids: this.props.topic.votedBy
      })

      this.setState({ votedUsers: res.data })
    }
  }

  render ({ topic, currentUser, pinnedReply, currentPage }: Props,
          { content, isCurrentUserVoted, votedUsers, showEditor, isLoading, editorErrors, tags, isSubscribed, hideFirstPost }: State) {
    const { author } = topic
    return (
      <div>
        <div className={`post box__pad qa-topic-post-box post--odd js-toggle-target ${hideFirstPost ? 'is-hidden' : ''}`}>
          <Portal into={'.ideation-topic-votes'}>
            <div className='ideation-topic-votes-wrapper'>
              <TopicVote
                displayText
                currentUserVoted={isCurrentUserVoted}
                numberOfVotes={Object.keys(votedUsers).length}
                onClick={this.toggleVoteStatus}
              />
              {
                Object.keys(votedUsers).length ? (
                  <VotedUsers votedUsers={Object.keys(votedUsers).map(id => votedUsers[id])} previewCount={5} isCurrentUserVoted={isCurrentUserVoted} />
                ) : null
              }
            </div>
          </Portal>
          <div className='post__user__info'>
            <UserAvatar
              user={{ ...author, ...{ name: author.username } }}
              extraClass='avatar avatar--responsive'
              showRank
            />
          </div>
          <div className='post__user__meta'>
            <ul className='list list--dot-seperated text--meta'>
              <li>
                <div className='group--inline'>
                  <a href={`/members/user-${author.id}`}>{ author.username }</a>
                </div>
              </li>
              <li className='is-hidden-S'>
                <Phrase p='topic.meta.post.reply' count={{ n: author.reputation.repliesMade.toString() }} />
              </li>
            </ul>
          </div>
          <div>
            {
              showEditor ? (
                <div className='post__content post__edit'>
                  <Editor
                    data={this.state.content}
                    attachments={[]}
                    canHavePoll={false}
                    isLoading={isLoading}
                    errors={editorErrors}
                    onSubmit={this.onChangeOpeningPost}
                    onCancel={() => this.setState({ showEditor: false })}
                    onChange={(content: string) => {
                      this.content = content
                    }} />
                </div>
              ) : (
                <div>
                  <Content
                    content={content || ''}
                    className='post__content qa-topic-post-content post__content--new-editor'
                  />
                  { pinnedReply && <PinnedReplyInContent pinnedReply={pinnedReply}/>}
                </div>
              )
            }
          </div>
          {
            this.isProductAreasEnabled ? (
              <TopicPublicTags
                topicId={topic.id}
                contentType='ideas'
                tags={tags}
                canUserEdit={this.canUserEditPost}
                onChange={(newTags) => this.setState({ tags: newTags })}
              />
            ) : null
          }
          <div className='post__footer post__footer-wrapper qa-topic-post-footer'>
            <TopicFavorite onCallback={this.toggleSubscription} className='post-footer-item text--meta' isActive={isSubscribed} />
            {
              this.canUserEditPost ? (
                <TopicMore>
                  <li onClick={() => this.setState({ showEditor: true })}><Phrase p='Edit' /></li>
                </TopicMore>
              ) : null
            }
          </div>
        </div>
        {
          currentPage > 1 ? (
            <a href='#' className='first-post__close' onClick={() => this.setState({ hideFirstPost: !hideFirstPost })}>
              {
                hideFirstPost ? <Phrase p='showFirstpost.message' /> : <Phrase p='hideFirstpost.message' />
              }
            </a>
          ) : null
        }

      </div>
    )
  }
}

const PinnedReplyInContent = ({ pinnedReply } : { pinnedReply: PostType }) =>
    <div className='post__content pinned-reply__label--firstpost'>
      <PinnedReplyLabel phrase={<Phrase p='reply.pinned' m='Forum' />} />
      <div className="post--pinned pinned-reply-field">
        <p className="pinned-reply-field__header">
          <div className="pinned-reply-field__user-info">
            <UserAvatar
              user={{ ...pinnedReply.author, ...{ name: pinnedReply.author.username } }}
              extraClass='avatar avatar--responsive avatar--pinned-reply'
              showRank
              />
            {
              pinnedReply.author.id.toString() === '' ?
                (<span className='pinned-reply__username'> { pinnedReply.author.username } </span>):
              (<a href={`/members/user-${pinnedReply.author.id}`}>{ pinnedReply.author.username }</a>)
            }
          </div>
          <span className="text--meta"><Tooltip
            withArrow
            trigger={(
              <time> { common.relativeDate(new Date(pinnedReply.repliedAt).getTime()) } </time>
            )}
            tooltipMessage={(
              <div className='tooltip__content tooltip__content--publish-date js-tooltip-content position--bottom'>
                { formatDateInLocalTimezone(new Date(pinnedReply.repliedAt).getTime()) }
              </div>
            )}
          /></span>
        </p>
        <Content content={pinnedReply.content} className='pinned-reply__content'/>
      </div>
    </div>

export default IdeationTopicView
